import ExerciseStore from '../storage/ExerciseStore.js'

class ExerciseItem extends HTMLElement {
  connectedCallback() {
    this.#render()
  }

  #deleteExercise = (event) => {
    const id = this.id
    const name = this.querySelector("h4").textContent
    if (id) {
      if (confirm(`Delete ${name}?`)) {
        const exercise = ExerciseStore.get(id)
        ExerciseStore.delete(exercise)
        this.dispatchEvent(new CustomEvent('gime-delete-exercise', { detail: { id }, bubbles: true }))
      }
    }
  }

  #editExercise = () => {
    this.dispatchEvent(new CustomEvent("gime-edit-exercise", { detail: { id: this.id }, bubbles: true }))
  }

  #render() {
    this.querySelectorAll("button[data-delete]").forEach( (button) => {
      button.addEventListener("click", this.#deleteExercise)
    })
    this.querySelectorAll("button[data-edit]").forEach( (button) => {
      button.addEventListener("click", this.#editExercise)
    })
  }
}

export default ExerciseItem
